import { Image } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';

function SelectedWorks() {
  return (
    <>
      <div className="px-4 py-5 my-4 text-left">
        <div className="col-lg-12 mb-4 ">
          <hr />
          <h2>&#92;&#92; SELECTED WORKS</h2>
          <hr />

          <div className="row">
            <div className="col-md-6 col-xs-3 col-lg-6 d-flex align-items-center justify-content-center flex-column">
              <a href="https://maira-dq1d.onrender.com/">
                <Image src="/MM.png" height={isMobile ? 200 : 400} width={isMobile ? 300 : 600}></Image>
              </a>
              <div>
                <p className="lead">&#92;&#92; Maira Meagher, Sexologe</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 d-flex align-items-center justify-content-center flex-column">
              <a href="https://www.queersexedcc.com/">
                <Image src="/QSE.png" height={isMobile ? 200 : 400} width={isMobile ? 300 : 600}></Image>
              </a>
              <div>
                <p className="lead">&#92;&#92; Queer Sex Ed Curriculum</p>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </>
  );
}

export default SelectedWorks;
